import React, { useRef, useEffect } from 'react';
import { Menu } from 'primereact/menu';
import { useToast } from "../../hooks/useToast.ts";
import { useGetUserQuery } from '../../services/usersApi';


const TaskContextMenu = ({
    task,
    visible,
    position,
    onHide,
    onTaskSelected,
    onDeleteRequest,
    onCreateTaskRequest,
    refetchTasks,
    tasks,
    projects = [],
    selectedUser = []
}) => {
    const menuRef = useRef(null);
    const toast = useToast();
    const { data: currentUser } = useGetUserQuery();

    useEffect(() => {
        if (visible && menuRef.current) {
            const syntheticEvent = {
                clientX: position.x,
                clientY: position.y,
                preventDefault: () => { },
                stopPropagation: () => { },
                target: document.body
            };
            menuRef.current.show(syntheticEvent);
        }
    }, [visible, position]);

    const getNextDisplayOrder = (projectId, tasks) => {
        const projectTasks = tasks.filter(t => t.project === projectId);
        const maxOrder = projectTasks.length > 0
            ? Math.max(...projectTasks.map(t => t.displayOrder || 0))
            : 0;
        return maxOrder + 1;
    };

    const getDisplayOrderAfterParent = (parentTask, tasks) => {
        const projectId = parentTask.type === "task" ? parentTask.project : parentTask.id;
        const projectTasks = tasks
            .filter(t => t.project === projectId)
            .sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));

        const parentIndex = projectTasks.findIndex(t => t.id === parentTask.id);
        if (parentIndex === -1) {
            return getNextDisplayOrder(projectId, tasks);
        }

        const nextIndex = parentIndex + 1;
        if (nextIndex >= projectTasks.length) {
            // Parent is last, insert after it
            return (projectTasks[parentIndex].displayOrder || 0) + 1;
        } else {
            // Insert between parent and next task
            const parentOrder = projectTasks[parentIndex].displayOrder || 0;
            const nextOrder = projectTasks[nextIndex].displayOrder || 0;
            return (parentOrder + nextOrder) / 2;
        }
    };

    const handleAddTask = (dependent) => {
        let startDate, endDate;
        
        if (dependent) {
            // Dependent task starts when parent finishes
            startDate = new Date(task.end);
            endDate = new Date(startDate.getTime());
            endDate.setMonth(endDate.getMonth() + 1);
        } else {
            // Independent task starts today
            startDate = new Date();
            startDate.setHours(0, 0, 0, 0);
            endDate = new Date(startDate.getTime());
            endDate.setMonth(endDate.getMonth() + 1);
        }
        
        const draftTask = {
            name: '',
            type: 'task',
            start: startDate,
            end: endDate,
            dependencies: dependent ? [task.id] : [],
            project: task.type === "task" ? task.project : task.id,
            hideChildren: false,
            users: selectedUser || [],
            progress: 0,
            displayOrder: getDisplayOrderAfterParent(task, tasks)
        };

        if (onCreateTaskRequest) {
            onCreateTaskRequest(draftTask);
        }
        onHide();
    };

    const handleShowFullForm = () => {
        onTaskSelected(task._id);
        onHide();
    };



    const items = [
        {
            label: 'Opcje',
            items: [
                {
                    label: 'Dodaj zadanie',
                    icon: 'pi pi-plus',
                    command: () => handleAddTask(false),
                    visible: currentUser?.type === 'admin' || (currentUser?.type === 'manager' && projects.find(p => p.id === (task.type === 'project' ? task.id : task.project))?.coordinators?.includes(currentUser._id))
                },
                {
                    label: 'Dodaj zadanie zależne',
                    icon: 'pi pi-plus',
                    command: () => handleAddTask(true),
                    visible: currentUser?.type === 'admin' || (currentUser?.type === 'manager' && projects.find(p => p.id === (task.type === 'project' ? task.id : task.project))?.coordinators?.includes(currentUser._id))
                },
                {
                    label: 'Edycja',
                    icon: 'pi pi-pencil',
                    command: handleShowFullForm,
                    visible: true
                },
                {
                    label: 'Usuń',
                    icon: 'pi pi-trash',
                    command: () => onDeleteRequest(task),
                    visible: currentUser?.type === 'admin' || (currentUser?.type === 'manager' && projects.find(p => p.id === (task.type === 'project' ? task.id : task.project))?.coordinators?.includes(currentUser._id))
                }
            ].filter(item => item.visible !== false)
        }
    ];

    return (
        <div style={{
            position: 'fixed',
            left: 0,
            top: 0,
            zIndex: 1000,
            pointerEvents: 'none'
        }}>
            <Menu
                model={items}
                popup
                ref={menuRef}
                onHide={onHide}
                style={{
                    position: 'absolute',
                    left: position.x,
                    top: position.y
                }}
            />
        </div>
    );
};

export default TaskContextMenu;